import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'

const Footer = () => {
  return (
    <Box alignItems="center" padding={16} backgroundColor="BG_WHITE" direction="row" justifyContent={'center'}>
      <Text fontSize={12.8} color={'#858796' as ColorOptions} fontFamily={'jiotype-medium'}>
        Copyright &copy; JioPay Services 2026
      </Text>
      <Spacer size={8} direction={'horizontal'} />
      <Text fontSize={12.8} color={'#858796' as ColorOptions} fontFamily={'jiotype-medium'} title={'v2.0.0'} />
    </Box>
  )
}

export { Footer }
